export type SubscriptionStatus = 'active' | 'cancelled' | 'redemption';

export type Subscription = {
  status: SubscriptionStatus;
  productName: string;
  extraData?: Partial<{
    type: string;
  }>;
};

export const isActiveSubscription = (subscription: Subscription): boolean => {
  return subscription.status === 'active';
};

export const isChatSubscription = (subscription: Subscription): boolean => {
  return !!subscription.extraData && !!subscription.extraData.type;
};
